module.exports = __webpack_public_path__ + "static/media/music_director.f9e0b751.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/music_director.svg
// module id = 919
// module chunks = 0